import { Link } from 'react-router-dom';
import AskIfMark from './AskIfMark';

export default function AskIfFab() {
  return (
    <Link
      to="/jarvis"
      aria-label="Ask IF"
      className="print-hidden lg:hidden fixed z-40 flex h-14 w-14 items-center justify-center rounded-full bg-navy shadow-lg ring-2 ring-gold right-4 bottom-[max(1.25rem,calc(1rem+env(safe-area-inset-bottom)))]"
    >
      <AskIfMark size={30} showLabel={false} />
    </Link>
  );
}
